import { axiosInstance, axiosRequestWithAuth } from './../constants/server.constant';

export const RegionService = {
    getByProject,
    getRegionListByType,
    getAll,
    getAllAvailabilityZone,
    getAllRegions
};

function getUserId() {
    return localStorage.getItem('userId');
}

async function getByProject(type) {
    return await axiosInstance.get('/regions/' + type + '/' + getUserId(), axiosRequestWithAuth)
        .then(regions => {
            return regions.data;
        }).catch(function (error) {
            return [];
        });
}

async function getRegionListByType(type) {
    return await axiosInstance.get(`/regions/` + type, axiosRequestWithAuth)
        .then(regions => {
            return regions.data;
        }).catch(function (error) {
            return [];
        });
}

async function getAll() {
    return await axiosInstance.get("/regions/all", axiosRequestWithAuth)
        .then(resp => {
            let region = [];
            for(let i = 0; i < resp.data.length; i++) {

                let reg = resp.data[i];
                let statusName = '';
                let statusClass = '';
                if(reg.status === 2) {
                    statusName = 'Upcoming';
                    statusClass = 'up_coming';
                } else if(reg.status === 3) {
                    statusName = 'Under Maintenance';
                    statusClass = 'under_mainteance';
                }

                let obj = {
                    id: reg.region_id,
                    name: reg.name,
                    countryName: reg.country_name,
                    status: reg.status,
                    statusName: statusName,
                    statusClass: statusClass,
                    capacity: Number(reg.vcpu_allocation_pct),
                    lbregionstatus: reg.lb_status

                };

                region.push(obj);
            }
            localStorage.setItem('fullRegionList', JSON.stringify(resp.data));
            region.sort(function (a, b) {
                if(Number(a.status) < Number(b.status)) { return -1; }
                else if(Number(a.status) > Number(b.status)) { return 1; }
                else {
                    if(a.capacity < b.capacity) { return 1; }
                    if(a.capacity > b.capacity) { return -1; }
                    return 0;
                }

            });
            return region;
        })
        .catch(error => {
            return false;
        });
}
async function getAllRegions() {
    return await axiosInstance.get("/regions/listregions", axiosRequestWithAuth)
        .then(resp => {
            let region = [];
            for(let i = 0; i < resp.data.length; i++) {

                let reg = resp.data[i];
                let statusName = '';
                let statusClass = '';
                if(reg.status === 2) {
                    statusName = 'Upcoming';
                    statusClass = 'up_coming';
                } else if(reg.status === 3) {
                    statusName = 'Under Maintenance';
                    statusClass = 'under_mainteance';
                }

                let obj = {
                    id: reg.region_id,
                    name: reg.name,
                    countryName: reg.country_name,
                    status: reg.status,
                    statusName: statusName,
                    statusClass: statusClass,
                    capacity: Number(reg.vcpu_allocation_pct),
                    lbregionstatus: reg.lb_status

                };

                region.push(obj);
            }
            localStorage.setItem('allRegionList', JSON.stringify(resp.data));
            region.sort(function (a, b) {
                if(Number(a.status) < Number(b.status)) { return -1; }
                else if(Number(a.status) > Number(b.status)) { return 1; }
                else {
                    if(a.capacity < b.capacity) { return 1; }
                    if(a.capacity > b.capacity) { return -1; }
                    return 0;
                }

            });
            return region;
        })
        .catch(error => {
            return false;
        });
}
async function getAllAvailabilityZone() {
    return await axiosInstance.get("/regions/avail-zone/all/" + getUserId(), axiosRequestWithAuth)
        .then(resp => {
            let region = [];
            for(let i = 0; i < resp.data.length; i++) {

                let reg = resp.data[i];
                let statusName = '';
                let statusClass = '';
                if(reg.status === 2) {
                    statusName = 'Upcoming';
                    statusClass = 'up_coming';
                } else if(reg.status === 3) {
                    statusName = 'Under Maintenance';
                    statusClass = 'under_mainteance';
                }

                let obj = {
                    id: reg.region_id,
                    name: reg.name,
                    countryName: reg.country_name,
                    status: reg.status,
                    statusName: statusName,
                    statusClass: statusClass,
                    availability_zone: reg.availability_zone,
                    capacity: Number(reg.vcpu_allocation_pct),
                    lbregionstatus: reg.lb_status
                };

                region.push(obj);
            }
            region.sort(function (a, b) {
                if(Number(a.status) < Number(b.status)) { return -1; }
                else if(Number(a.status) > Number(b.status)) { return 1; }
                else {
                    if(a.capacity < b.capacity) { return 1; }
                    if(a.capacity > b.capacity) { return -1; }
                    return 0;
                }

            });
            return region;
        })
        .catch(error => {
            return false;
        });
}

export default RegionService;